import type { ReactNode } from "react";
import { frameAttentionText, useFrameAttention } from "./use-frame-attention";

/** An empty body keeps error details readable without covering saved content. */
export function FrameEmptyState({
  frameId,
  status,
  testId,
  children,
}: {
  frameId: string;
  status: string;
  testId: string;
  children: ReactNode;
}) {
  const attention = useFrameAttention(frameId);
  const message =
    status === "error"
      ? frameAttentionText(
          attention?.kind === "error"
            ? attention
            : { kind: "error", message: null },
        )
      : children;
  return (
    <p
      className="flex min-h-0 flex-1 items-center justify-center text-center text-appkit-small text-muted"
      data-testid={testId}
    >
      {message}
    </p>
  );
}
